import { Link } from "react-router-dom";
import { useLang, PAGES } from "../i18n/LangContext";

const VARIANTS = {
  primary: "bg-mint text-verde-950 hover:bg-white",
  dark: "bg-verde-800 text-white hover:bg-verde-700",
  "ghost-light": "border border-white/25 text-white hover:bg-white/10",
};

const LABELS = { en: "Book a meeting", pt: "Marcar reunião" };

export default function BookMeeting({ label, variant = "dark", testid = "book-meeting" }) {
  const { lang, lp } = useLang();
  return (
    <Link
      to={lp("/book")}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-sm font-semibold transition-colors duration-300 ${VARIANTS[variant] || VARIANTS.dark}`}
    >
      {label || LABELS[lang]}
    </Link>
  );
}
